export const GET_REGISTRATION_LINK_STATUS_CALL = 'GET_REGISTRATION_LINK_STATUS_CALL';
export const GET_REGISTRATION_LINK_STATUS_DONE = 'GET_REGISTRATION_LINK_STATUS_DONE';
export const GET_REGISTRATION_LINK_STATUS_FAIL = 'GET_REGISTRATION_LINK_STATUS_FAIL';
export const RESET_REGISTRATION_LINK_STATUS = 'RESET_REGISTRATION_LINK_STATUS';

export const POST_CREATE_REGISTRATION_EMAIL_USER_CALL = 'POST_CREATE_REGISTRATION_EMAIL_USER_CALL';
export const POST_CREATE_REGISTRATION_EMAIL_USER_DONE = 'POST_CREATE_REGISTRATION_EMAIL_USER_DONE';
export const POST_CREATE_REGISTRATION_EMAIL_USER_FAIL = 'POST_CREATE_REGISTRATION_EMAIL_USER_FAIL';

export const POST_CREATE_REGISTRATION_MOBILE_USER_CALL = 'POST_CREATE_REGISTRATION_MOBILE_USER_CALL';
export const POST_CREATE_REGISTRATION_MOBILE_USER_DONE = 'POST_CREATE_REGISTRATION_MOBILE_USER_DONE';
export const POST_CREATE_REGISTRATION_MOBILE_USER_FAIL = 'POST_CREATE_REGISTRATION_MOBILE_USER_FAIL';

export const POST_REGISTER_REGISTRATION_LINK_USER_CALL = 'POST_REGISTER_REGISTRATION_LINK_USER_CALL';
export const POST_REGISTER_REGISTRATION_LINK_USER_DONE = 'POST_REGISTER_REGISTRATION_LINK_USER_DONE';
export const POST_REGISTER_REGISTRATION_LINK_USER_FAIL = 'POST_REGISTER_REGISTRATION_LINK_USER_FAIL';

export const POST_REGISTRATION_LINK_LOGIN_VERIFY_CALL = 'POST_REGISTRATION_LINK_LOGIN_VERIFY_CALL';
export const POST_REGISTRATION_LINK_LOGIN_VERIFY_DONE = 'POST_REGISTRATION_LINK_LOGIN_VERIFY_DONE';
export const POST_REGISTRATION_LINK_LOGIN_VERIFY_FAIL = 'POST_REGISTRATION_LINK_LOGIN_VERIFY_FAIL';
